import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errorText } from "@/lib/api";

export default function AuthCallback({ t, onAuth }) {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", location.pathname);
    api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } })
      .then((r) => { onAuth(r.data); navigate("/workspace", { replace: true, state: { user: r.data } }); })
      .catch((err) => setError(errorText(err, "Google sign-in failed.")));
  }, [location, navigate, onAuth]);

  return (
    <div className="loading" data-testid="auth-callback">
      {error ? <div><div className="form-error" data-testid="auth-callback-error">{error}</div><button className="text-button" onClick={() => navigate("/login", { replace: true })} data-testid="auth-callback-back">{t.sign}</button></div> : t.googleWait}
    </div>
  );
}
